/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsSummarizationService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './SalesDocumentsSummarizationService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsSummarizationService#summarizeDocument
 */
export const SUMMARIZE_DOCUMENT_MUTATION_FIELD_NAME = 'com_hubspot_sales_documents_rpc_SalesDocumentsSummarizationService_summarizeDocument';
export const SUMMARIZE_DOCUMENT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SUMMARIZE_DOCUMENT_MUTATION_FIELD_NAME,
  args: ['documentId', 'summarizationVersion', 'summarizationOptions'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.summarizeDocumentRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsSummarizationService#updateDocumentSummary
 */
export const UPDATE_DOCUMENT_SUMMARY_MUTATION_FIELD_NAME = 'com_hubspot_sales_documents_rpc_SalesDocumentsSummarizationService_updateDocumentSummary';
export const UPDATE_DOCUMENT_SUMMARY_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_DOCUMENT_SUMMARY_MUTATION_FIELD_NAME,
  args: ['documentId', 'text'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.updateDocumentSummaryRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsSummarizationService#getDocumentSummary
 */
export const GET_DOCUMENT_SUMMARY_MUTATION_FIELD_NAME = 'com_hubspot_sales_documents_rpc_SalesDocumentsSummarizationService_getDocumentSummary';
export const GET_DOCUMENT_SUMMARY_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: GET_DOCUMENT_SUMMARY_MUTATION_FIELD_NAME,
  args: ['documentId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getDocumentSummaryRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsSummarizationService#submitFeedback
 */
export const SUBMIT_FEEDBACK_MUTATION_FIELD_NAME = 'com_hubspot_sales_documents_rpc_SalesDocumentsSummarizationService_submitFeedback';
export const SUBMIT_FEEDBACK_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SUBMIT_FEEDBACK_MUTATION_FIELD_NAME,
  args: ['correlationId', 'vote', 'feedbackGeneric', 'feedbackFreeform'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.submitFeedbackRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});